<template>
    <div>
        <v-row>
            <v-col cols="2">
                <div>
                    <div>
                        <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-autocomplete
                                    v-model="categoryFilter"
                                    :items="categories"
                                    :menu-props="{ maxHeight: '400' }"
                                    item-text="name"
                                    item-value="id"
                                    label="Kategoria"
                                    multiple
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-autocomplete>
                            </template>
                        </v-menu>
                        <v-checkbox v-model="mainFilter"
                                    v-bind="attrs"
                                    v-on="on"
                                    label="Strona główna"
                        ></v-checkbox>
                    </div>
                </div>
            </v-col>
            <v-col cols="10">
                <data-table
                    ref="table"
                    :headers="headers"
                    :items="pageContents"
                    :options.sync="options"
                    :server-items-length="totalPageContents"
                    :loading="loading"
                    class="row-pointer"
                    @click:row="onRowClicked"
                >
                  <template v-slot:item.category="{ item }">
                    {{ item.category ? item.category.name : 'Główna lista' }}
                  </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from '../services/api';
import debounce from 'debounce';
import DataTable from "@/components/data-table/DataTable";
import formatters from '@/mixins/formatters';
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
import permissions from '@/mixins/permissions';

export default {
    mixins: [
        formatters,
        permissions,
    ],
    components: {
        DataTable,
    },
    data() {
        return {
            pageContents: [],
            totalPageContents: 0,
            loading: true,
            options: {},
            headers: [
                {text: 'Kategoria', value: 'category', sortable: false},
            ],
            menu1: false,
            menu2: false,
            filters: {
                category:null,
            },
            categoryFilter: null,
            mainFilter: null,
            categories: []
        }
    },
    watch: {
        options: {
            handler() {
                this.getOfferContents();
                setDatatableOptions.call(this);
            },
            deep: true,
        },
        categoryFilter() {
            this.getOffersFilteredByCategory();
        },
        mainFilter() {
            this.getOffersFilteredByMain();
        },
    },
    methods: {
        async getOfferContents() {
            const {page, itemsPerPage} = this.options;

            this.loading = true;

            const params = {
                offset: page > 1 ? itemsPerPage * (page - 1) : 0
            };

            if (-1 !== itemsPerPage) {
                params.limit = itemsPerPage;
            }

            if (this.categoryFilter) {
                params.category = this.categoryFilter;
            } else {
                delete params.category;
            }

            if (this.mainFilter) {
                params.main = true;
                delete params.category;
            } else {
                delete params.main;
            }
            const response = await api.get('/api/offer-content', {params});
            this.loading = false;

            this.pageContents = response.data.items;
            this.totalPageContents = response.data.total;
        },
        async getCategories() {
            const response = await api.get('/api/categories?level=0');
            this.categories = response.data.categories;
        },
        onRowClicked(pageContent) {
            this.$router
                .push({name: 'offer-content-details', params: {id: pageContent.id}})
                .catch((error) => {
                    if (String(error).includes('Avoided redundant navigation to current location')) {
                        return;
                    }

                    throw error;
                });
        },
    },
    created() {
        getDatatableParams.call(this);
        this.getCategories();
        this.getOffersFilteredByCategory = debounce(function () {
            this.getOfferContents();
        }, 500);
        this.getOffersFilteredByMain = debounce(function () {
            this.getOfferContents();
        }, 500);
    }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>